import request from '@/utils/zsm-requets'
const bunchPlanting = '/zsm/api/douyin/bunchPlanting/'
/**
 * 抖音云获取上传凭证
 * @param fileUrl 文件地址
 * @returns 
 */
export function uploadAuthToken() {
  return request({
    url: bunchPlanting + 'uploadAuthToken',
    method: 'get'
  })
}

/**
 * 获取抖音云上传地址
 * @param vId vId
 * @returns 
 */
export function getPlayBackAddress(vId) {
  return request({
    url: bunchPlanting + 'getPlayBackAddress',
    method: 'post',
    params:{vId}
  })
}





/**
 * 发送到抖音云
 * @param fileUrl 文件地址
 * @returns 
 */
export function getUploadPathAndToken(fileUrl) {
  return request({
    url: bunchPlanting + 'getUploadPathAndToken',
    method: 'post',
    params:{fileUrl}
  })
}

